module.exports = __webpack_public_path__ + "img/1716365315617-WhatsApp Image 2024-05-22 at 14.10.12 1.jpeg.8ec7f8af.webp";